import type { APIUserProp } from '../interfaces/propsService/api';
import type { TUserProp } from '../interfaces/propsService/parsed/props';

const parseUserProp = (response: APIUserProp): TUserProp => {
  const { related_props: unusedRelatedProps, ...rest } = response;
  return {
    ...rest,
    game_start: new Date(response.game_start),
    score: response.score ?? 0,
  };
};

export default parseUserProp;
